export const LOAD_ACCOUNTHUB_LOB_WISE = 'loadAccountHubLobWise';
export const SEND_EMAIL_QUOTE_SCHEMA = 'sendEmailQuoteSchema';
export const SEND_EMAIL_QUOTE_ON_FORM_SUBMIT = 'sendEmailQuoteOnFormSubmit';
export const QUICK_QUOTE_USE_EFFECT_LOGIC = 'quickQuoteUseEffectLogic';
export const DOWNLOAD_QUOTE_INDICATION_DOCUMENT = 'downloadQuoteIndicationDocument';
export const QUOTE_SCHEMA_RELATED_OPERATION = 'quoteSchemaRelatedOperation';
export const RENDER_FEES_AND_TAXES = 'renderFeesAndTaxes';
export const GET_INPUT_CLAUSES = 'getInputClause';
export const ADD_DEFAULT_VALUES = 'AddDefaultValues';
export const LOAD_ACCOUNTHUB_DATA = 'processAccountHubData';
export const SHOW_DIFFERENCES = 'showDifferences';
export const CALCULATE_DWELLING_AND_TIV = 'calculateDwellingAndTIV';
export const FETCH_PASSIVE_POLICIES = 'FetchPassivePolicies';
export const LOAD_PASSIVE_POLICIES = 'loadPassivePolicies';
export const REPLACE_DATA = 'replaceData';
export const REPLACE_ADVANCE_SEARCH = 'replaceAdvanceSearch';
export const LOAD_POLICY_DATA = 'loadPolicyData';
export const LOAD_POLICY_DATA_MASTER = 'loadPolicyDataMaster';

export const SUMMARY_CARD = 'SummaryCard';
export const SET_DEFAULT_VALUES_HANDLER = 'setDefaultValuesHandler';
export const SET_DEFAULT_VALUES_HANDLER_ENDORSEMENT = 'setDefaultValuesHandlerEndorsement';
export const ROUTER_LANDING = 'routerLanding';
export const INITIAL_FILE_CHANGES = 'initialFileChanges';
export const ADDREMOVEOPTIONALFORMBUTTON = 'addRemoveOptionalFormButton';
export const LOB_LIST_SHORT_HAND = 'LOBListShortHand';
export const GET_FILES_LIST_FROM_DMS = 'getFilesListFromDMS';
export const COMMON_KEY_FETCHER = 'commonkeyfetcher';

export const POST_CANCEL_ACTIONS = 'postCancelActions';
export const POST_REINSTATE_ACTIONS = 'postReinstateActions';

export const PAGE_POLICYHOLDER = 'PolicyHolder';
export const BASE_HELPER = 'baseHelper';
export const FILTER_ACCOUNTHUB_HUB_DATA = 'filterAccountHubData';
export const ACCOUNTHUB_EXPAND_ROW = 'accountHubExpandRow';
export const ACCOUNTHUB_EXPAND_ROW_FILTER = 'accountHubExpandRowFilter';

export const SET_SCHEMA_ON_CHANGE = 'setSchemaOnChange';
export const APPROVE_AND_OFFER_QUOTE_CONDITIONS = 'approveAndOfferQuoteCondtions';

export const FETCH_POLICY_STATUS_HISTORY = 'fetchPolicyStatusHistory';
export const FETCH_TRANSACTION_HISTORY = 'fetchTransactionHistory';
export const LOAD_CHILD_POLICIES = 'loadChildPolicies';

export const TABLE_COLS = 'tableCols';
export const CUSTOM_BUTTON_CONFIGURATIONS = 'customButtonConfigurations';

export const SET_DEFAULT_VALUES_HANDLER_CANCELLATION = 'setDefaultValuesHandlerCancellation';
export const SET_DEFAULT_VALUES_HANDLER_REINSTATEMENT = 'setDefaultValuesHandlerReinstatement';
export const GET_CUSTOM_START_ENDORSEMENT_REDIRECTION = 'getCustomStartEndorsementRedirection';
